import { useMutation, useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import { useAuthStore } from '@/stores/authStore';
import type { LoginRequest, LoginResponse } from '@/types/api';

declare global {
  interface Window {
    __OPS_MODE__?: boolean;
  }
}

export function useLogin() {
  const { setUser } = useAuthStore();
  return useMutation({
    mutationFn: async (body: LoginRequest) => {
      const res = await apiClient.post<LoginResponse>('/auth/login', body);
      return res.data;
    },
    onSuccess: (data) => {
      setUser(data.data);
      // ops mode (port 8501): redirect to realtime dispatch monitoring directly
      window.location.href = window.__OPS_MODE__ ? '/dispatch-sop' : '/';
    },
  });
}

export function useLogout() {
  const { setUser } = useAuthStore();
  return useMutation({
    mutationFn: async () => {
      await apiClient.post('/auth/logout');
    },
    onSuccess: () => {
      setUser(null);
      window.location.href = '/login';
    },
  });
}

export function useCurrentUser() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      const res = await apiClient.get<LoginResponse>('/me');
      return res.data.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
}
